<template>
<body>
  <div class="concierce_wrapper">
    <!-- header -->
    <div class="layer_header">
      <div class="header_inner">
        <div class="header_logo">
          <h1>
            <a @click="closeBtn">Amway</a>
          </h1>
        </div>
        <button type="button" class="btn_layer_close" @click="closeBtn">닫기</button>
      </div>
    </div>
    <!-- contents-->
    <div class="contents">
      <div class="voucher_post_box">
        <div class="voucher_post">
          <img src="./images/concierce_voucher_mo.png" alt="DIAMOND CONCIERGE PHYTO CAFE 음료바우처">
        </div>
      </div>

      <!-- S: ASB-12562 추가 -->
      <counter
        text="선물"
        ref="counter__component"
        :totalCouponSum="totalCouponSum"
      />
      <!-- E: ASB-12562 -->

      <div class="voucher_contact">
        <h2 class="title">선물 받으실 분의 휴대폰 번호를 입력해주세요.</h2>
        <div class="contact_tel">
          <div class="contact_tel_1">
            <select class="form-tel" v-model="preNumber" title="휴대폰번호 앞자리 입력">
              <option :key="i" :value="op.num" v-for="(op, i) in optionBox">{{ op.num }}</option>
            </select>
          </div>
          <div class="contact_tel_2">
            <input type="number" v-model.number="postNumber" required minlength="4" maxlength="8" size="10"
                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                   class="form-tel" placeholder="-없이 입력" title="휴대폰번호 뒷자리 입력" ref="phone__element">
          </div>
        </div>
        <div class="contact_marketing_agree">
          <input type="checkbox" v-model="term1" id="marketing_agree" class="form_agree">
          <label for="marketing_agree">
            파이토 카페 음료 바우처는 카카오 알림톡 또는 SMS로 전달됩니다. 수신자로부터 동의를 받으셨습니까?
          </label><!-- 20221005 수정 -->
        </div>
      </div>
      <div class="concierce_btn_area">
        <button v-if="term1" type="button" class="btn-pop-submit" @click="sendGiftFunc">선물 보내기</button>
        <button v-else type="button" class="btn-pop-submit" disabled>선물 보내기</button>
      </div>
    </div>
  </div>
</body>
</template>

<script>
// Component
import counter from './component/counter.vue'
// Library
import axios from 'axios'

export default {
  name: 'conciergeSendGift',
  components: {
    counter // ASB-12562 추가
  },
  props: {
    targetUserId: Number, // ASB-12562: userId -> targetUserId
    aboInfo: {},
    totalCouponSum: Number // ASB-12562 추가
  },
  data () {
    return {
      term1: Boolean,
      optionBox: Object,
      preNumber: String,
      postNumber: Number
    }
  },
  methods: {
    fullNumber: function () {
      return this.preNumber + this.postNumber
    },
    sendGiftFunc: function () {
      var regex = /[^0-9]/g
      var fnum = this.fullNumber().replace(regex, '')
      if (this.term1 && fnum.length > 10) {
        if (confirm('입력하신 전화번호는 ' + fnum + ' 입니다. \n 선물을 발송할까요?')) {
          if (fnum) this.sendGiftCallAsync()
        } else {
          alert('발송이 취소되었습니다.')
        }
      } else {
        alert('발송하실 전화번호를 확인하여 주시기 바랍니다.')
        this.$refs.phone__element.focus()
      }
    },
    closeBtn: function () {
      this.$router.go(-1)
    },
    sendGiftCallAsync: async function () {
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-send-gift',
        {
          tuid: this.targetUserId, // ASB-12562: user_id -> tuid, userId -> targetUserId
          gift_count: this.$refs.counter__component.selectedCP, // ASB-12562 추가
          send_num: this.fullNumber(), // ASB-12562: send_no -> send_num
          abo_no: this.aboInfo.aboNo,
          abo_nm: this.aboInfo.aboName,
          term1: (this.term1 ? 'Y' : 'N') // ASB-12562: term_1 -> term1
        }).then(response => {
        if (response.data.statusCode === 200) {
          switch (response.data.results) {
            case 'COUPON 0':
            case 'COUPON Not Enough':
              alert('쿠폰 보유수량이 부족합니다.')
              break
            default:
              alert('발송 되었습니다.')
          }
          this.closeBtn()
        } else {
          alert('500: Fail to send voucher')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    }
  },
  mounted () {
    this.term1 = false
    this.optionBox = [{num: '010'}, {num: '011'}]
    this.preNumber = '010'
    this.postNumber = ''
    window.scrollTo(0, 0)

    if (this.targetUserId === undefined) {
      alert('쿠폰 정보를 다시 확인합니다.')
      this.closeBtn()
    }
  }
}
</script>

<style scoped>
@import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/conciergeSendGift.vue